<template>
<div v-show="!fromClub">
  <h1 class='login-title'>Qooco DAS</h1>
  <el-form :model='ruleForm2' :rules='rules2' ref='ruleForm2' label-position='left' label-width='0px' class='demo-ruleForm login-container'>
    <h3 class='title'>欢迎登录</h3>
    <h6 class="errMsg" v-show="msg">{{msg}}</h6>
    <el-form-item prop='username'>
      <el-input type='text' v-model='ruleForm2.username' auto-complete='off' placeholder='账号'></el-input>
    </el-form-item>
    <el-form-item prop='password'>
      <el-input type='password' v-model='ruleForm2.password' auto-complete='off' placeholder='密码' @keyup.enter.native.prevent='handleSubmit2'></el-input>
    </el-form-item>
    <el-checkbox v-model='checked' checked class='remember'>记住密码</el-checkbox>
    <el-form-item style='width:100%'>
      <el-button type='primary' style='width:100%' @click.native.prevent='handleSubmit2'>登录</el-button>
      <!--<el-button @click.native.prevent='handleReset2'>重置</el-button>-->
    </el-form-item>
  </el-form>
</div>
</template>

<script>
// import { requestLogin } from 'api/api'
// import NProgress from 'nprogress'
import {fromClub} from 'common/js/app-utils'
import jquery from 'jquery'
export default {
  data () {
    return {
      fromClub: 'true',
      msg: '',
      logining: false,
      ruleForm2: {
        username: '',
        password: ''
      },
      rules2: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
          // { validator: validaePass }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
          // { validator: validaePass2 }
        ]
      },
      checked: true
    }
  },
  created () {
    this.fromClub = fromClub()
  },
  mounted () {
    if (fromClub()) { // 来自语吧，自动登录
      const loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(245, 245, 245, 1)'
      })
      jquery.getScript('https://club.qooco.com/das/sessionId', () => {
        if (window.sessionId) {
          setTimeout(() => loading.close(), 700)
          this.autoLoginWithClubSessionId()
          localStorage.setItem('lastClubSessionId', window.sessionId)
        } else {
          loading.text = '请重新登录club.qooco.com'
        }
      })
    }
  },
  methods: {
    handleReset2 () {
      this.$refs.ruleForm2.resetFields()
    },
    handleSubmit2 (ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          var redirect = this.$auth.redirect()
          // debugger
          this.$auth.login({
            body: this.ruleForm2, // Vue-resource
            rememberMe: this.checked,
            redirect: { name: redirect ? redirect.from.name : 'default' },
            fetchUser: true,
            success () {
              loading.close()
            },
            error (res) {
              loading.close()
              console.log('error1')
              console.log(res)
              this.msg = res.data.msg
            }
          })
        } else {
          this.msg = '请正确输入用户名和密码'
          return false
        }
      })
    },
    autoLoginWithClubSessionId () {
      this.ruleForm2.username = 'loginWithClub'
      this.ruleForm2.password = window.sessionId

      var redirect = this.$auth.redirect()
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(245, 245, 245, 1)'
      })
      this.$auth.login({
        body: this.ruleForm2, // Vue-resource
        rememberMe: this.checked,
        redirect: { name: redirect ? redirect.from.name : 'default' },
        fetchUser: true,
        success () {
          loading.close()
        },
        error (res) {
          loading.close()
          console.log(res)
          this.$loading({
            lock: true,
            text: res.data.msg + '--请关闭窗口5分钟后重试或联系管理员',
            spinner: 'el-icon-loading',
            background: 'rgba(245, 245, 245, 1)'
          })
        }
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~common/stylus/variable.styl'
.login-title {
  margin-top: 100px
  color: $color-theme
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  margin-top: 60px
}

.login-container {
  -webkit-border-radius: 5px
  border-radius: 5px
  -moz-border-radius: 5px
  background-clip: padding-box
  margin: 180px auto
  margin-top: 30px
  width: 350px
  padding: 35px 35px 15px 35px
  background: #fff
  border: 1px solid #eaeaea
  box-shadow: 0 0 25px #cac6c6

  .title {
    margin: 0px auto 40px auto
    text-align: center
    color: #505458
  }
  .errMsg{
    text-align: center
    color: red
    font-size: $font-size-medium-x
  }
  .remember {
    margin: 0px 0px 35px 0px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sys/login.vue